
// `pdfmake` needs ascii text-encoding which post expo sdk-51 no longer support.
// Therefore, we are using a polyfill

// text-decoder-polyfill.js
(function (globalScope) {
    // Clear the broken Hermes native implementation completely
    globalScope.TextEncoder = undefined;
    globalScope.TextDecoder = undefined;

    // Pull in the full standard polyfill
    var Lib = require('text-encoding');

    globalScope.TextEncoder = Lib.TextEncoder;
    globalScope.TextDecoder = Lib.TextDecoder;
})(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : this);

// Because different JavaScript environments name their root global object differently, the line
// `typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : this)`
// acts as an environmental detector loop. Here is the breakdown:
//
// 1. typeof global !== 'undefined' ? global : ...
// Target: Node.js and React Native (Hermes).
// Action: It checks if the variable global exists. In React Native/Hermes, this is true. If it finds it, it stops and uses global.
//
// 2. ... : typeof self !== 'undefined' ? self : ...
// Target: Web Browsers and Web Workers.
// Action: If global doesn't exist, it checks for self. Browsers use window, but inside background Web Workers, the global scope is called self.
//
// 3. ... : this
// Target: Fallback.
// Action: If neither is found, it falls back to whatever this evaluates to in the current execution context (usually the root file context).
//
// Modern JavaScript Note: Today, modern web standards have introduced a unified keyword called globalThis to replace this entire messy line.
// In modern setups, writing globalThis.TextDecoder = ... achieves the exact same result.